"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var tombacIcon_1 = require("../tombacIcon");
function SvgAreaAlt(props) {
    return (React.createElement("svg", tslib_1.__assign({ viewBox: "4 -4 16 24" }, props),
        React.createElement("path", { d: "M17 0a2 2 0 011.235 3.573l.51 3.57a2 2 0 01-1.262 3.79l-2.55 2.55A2.003 2.003 0 0113 16a2 2 0 01-1.94-1.514l-3.67-1.049a2 2 0 11-2.214-3.26l.656-6.553A2 2 0 118.732 1h6.536A2 2 0 0117 0zm-4 13a1 1 0 100 2 1 1 0 000-2zm-7-2a1 1 0 100 2 1 1 0 000-2zm12-3a1 1 0 100 2 1 1 0 000-2zm-1-7a1 1 0 100 2 1 1 0 000-2zM7 1a1 1 0 100 2 1 1 0 000-2z", fill: "currentColor" })));
}
exports.default = tombacIcon_1.default('AreaAlt')(SvgAreaAlt);
//# sourceMappingURL=AreaAlt.js.map